module.exports = __webpack_public_path__ + "static/img/2845_phase_function_Paper_PointsHejduk_Prediction.dd2a2a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2845_phase_function_Paper_PointsHejduk_Prediction.png
// module id = xgfP
// module chunks = 0